import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { SDKVersionGroup, SDKVersionGroupSearchParam } from '../models';
import { AlloxApiService } from './allox-api.service';

@Injectable({ providedIn: 'root' })
export class SDKVersionGroupService {

  private path = '/sdk_version_groups';

  constructor(private http: AlloxApiService) { }

  public search(param?: SDKVersionGroupSearchParam) {
    let url = this.path;
    if (param) {
      url += param.toURLQuery();
    }
    return this.http.get<[]>(url).pipe(
      map(objs => objs.map(obj => new SDKVersionGroup(obj))),
    );
  }

  public fetch(id: number) {
    return this.http.get(this.path + '/' + id).pipe(
      map(obj => new SDKVersionGroup(obj))
    );
  }

  public post(item: SDKVersionGroup) {
    const json = item.toJSON();
    return this.http.post(this.path, json);
  }

  public put(item: SDKVersionGroup) {
    const json = item.toJSON();
    return this.http.put(this.path + '/' + item.id, json);
  }

  public deletes(items: SDKVersionGroup[]) {
    const dItems = items.map(item => item.toDeleteItemJSON());
    return this.http.post(this.path + '/delete', { delete_items: dItems });
  }
}
